import { FadeIn } from "./FadeIn";
import { PROCESS_STEPS } from "@/lib/site";

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-7">
            <FadeIn>
              <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-accent font-semibold mb-5">
                How it works
              </p>
            </FadeIn>
            <FadeIn delay={0.1}>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-primary leading-[1.05]">
                Three steps
                <br />
                <span className="italic">to a perfect mango.</span>
              </h2>
            </FadeIn>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 relative">
          <div className="hidden md:block absolute top-8 left-[12%] right-[12%] h-px bg-brand-borderColor" />
          {PROCESS_STEPS.map((s, i) => (
            <FadeIn key={s.n} delay={i * 0.15}>
              <div
                className="relative"
                data-testid={`process-step-${s.n}`}
              >
                <div className="relative z-10 h-16 w-16 rounded-full border border-brand-borderColor bg-brand-base flex items-center justify-center font-display text-brand-accent text-lg">
                  {s.n}
                </div>
                <h3 className="mt-6 font-display text-2xl text-brand-primary">
                  {s.title}
                </h3>
                <p className="mt-3 text-brand-textMuted text-base leading-relaxed max-w-sm">
                  {s.body}
                </p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
